/* eslint-disable no-console */
import { ReactNode, useEffect, useRef } from 'react';
import AppLoader from 'src/components/AppLoader';
import { useAuth } from 'oidc-react';
import { useDispatch } from 'react-redux';

type Props = {
  children: ReactNode;
};

function AuthTemplate({ children }: Props) {
  const auth = useAuth();
  const dispatch = useDispatch();
  const tokenRenewalInterval = 45 * 60 * 1000; // 45 minutes
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleTokenRenewal = () => {
      if (!auth?.userData) {
        console.log('No user data available, skipping token renewal');
        return;
      }

      auth.userManager
        .signinSilent({ scope: 'openid profile email offline_access' })
        .then(async (user) => {
          if (user?.access_token) {
            localStorage.setItem('authToken', user.access_token);
            await auth.userManager.signinSilentCallback();
            console.log('Token renewed successfully');
          } else {
            console.warn('Silent signin did not return a user');
            auth.signOutRedirect();
          }
        })
        .catch((error) => {
          console.error('Silent signin failed:', error);
          if (
            error.error === 'login_required' ||
            error.error === 'consent_required'
          ) {
            auth.signOutRedirect();
          }
        });
    };

    intervalRef.current = setInterval(() => {
      handleTokenRenewal();
    }, tokenRenewalInterval);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [auth, dispatch, tokenRenewalInterval]);

  if (auth && auth.userData) {
    return children;
  }
  return <AppLoader />;
}

export default AuthTemplate;
